export const ChartProp = Object.freeze({
    ChartType: 'chartType',
    Title: 'title',
    Data: 'data',
    Buttons: 'buttons',
    HasLegend: 'hasLegend',
    BottomAxisLabel: 'bottomAxisLabel',
    LeftAxisLabel: 'leftAxisLabel',

    ComparisonValues: 'comparisonValues',
    GroupBy: 'groupBy',
    GroupMode: 'groupMode',
    Layout: 'layout',
    EnableTotals: 'enableTotals',
    EnableBarLabel: 'enableBarLabel',

    Curve: 'curve',
    EnableArea: 'enableArea',
    EnablePointLabel: 'enablePointLabel',
    UseMesh: 'useMesh',
});